module.exports = fox._r("fonts/simplifica.woff", __webpack_public_path__ + "_/_/_/root/fonts/1Vq6EH3.woff");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/simplifica.woff
// module id = 221
// module chunks = 4